/** Postal horn — honked at a player (their roster row, or their home base on
 * the board) it doubles as a "your turn!" nudge: the target's client sounds
 * the turn notification, and the server sends them a push notification.
 * Shared so the client (reaction effects) and server (push) agree on it. */
export const HONK_EMOJI = "\u{1F4EF}";
/** Emoji equality ignoring VS16 presentation selectors — pickers and
 * platforms disagree about emitting them (shield with/without VS16). */
export function sameEmoji(a, b) {
    return a.replace(/\uFE0F/g, "") === b.replace(/\uFE0F/g, "");
}
//# sourceMappingURL=emoji.js.map